import React from 'react';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import * as yup from 'yup';
import api from '../../../components/api';
import { yupErrorMsg } from '../../../components/atoms/const';

function useEditUserProfile() {
  // form schema for form changing password
  const { mutate: updatePassword, isLoading: passwordLoad } = useMutation(api.user.updatePassword, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      window.location.reload();
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });
  const yupSchemaLogin = yup.object({
    newPassword: yup.string().matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      yupErrorMsg.PASSWORD_INCORRECT_FORMAT,
    ).required(yupErrorMsg.PASSWORD_EMPTY),
    confirmPassword: yup.string().oneOf([yup.ref('newPassword'), null], yupErrorMsg.PASSWORD_NOT_MATCH)
      .required(yupErrorMsg.CONFIRM_PASS_EMPTY),
  });
  const formikLogin = useFormik({
    initialValues: {
      username: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    validationSchema: yupSchemaLogin,
    onSubmit: (values) => updatePassword({
      password: values.confirmPassword,
    }),
  });

  // form schema for changing personal info details
  const { mutate: updatePersonal, isLoading: personalLoad } = useMutation(api.user.update, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      alert('success');
      window.location.reload();
    },
    onError: (error) => {
      console.log(error);
      alert('error');
    },
  });
  const yupSchemaPersonal = yup.object({
    firstname: yup.string().required(yupErrorMsg.FIRST_NAME_EMPTY),
    lastname: yup.string().required(yupErrorMsg.LAST_NAME_EMPTY),
    phoneNumber: yup.string().required(yupErrorMsg.PHONE_NUMBER_EMPTY),
    position: yup.string().required(yupErrorMsg.POSITION_EMPTY),
  });
  const formikPersonal = useFormik({
    initialValues: {
      firstname: '',
      lastname: '',
      position: '',
      phoneNumber: '',
    },
    validationSchema: yupSchemaPersonal,
    onSubmit: (values) => updatePersonal(values),
  });

  // form schema for company info details that are unchangeable from Front End
  const formikCompany = useFormik({
    initialValues: {
      name: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
    },
    onSubmit: (values) => console.log(values),
  });

  const { data, isLoading } = useQuery(
    ['user', 'getProfileDetails'],
    () => api.user.getProfileDetails(),
  );

  React.useEffect(() => {
    const resData = data?.data?.data;
    if (resData) {
      // Login Part
      formikLogin.setFieldValue('username', resData.username ?? '');
      // Personal Info Part
      formikPersonal.setFieldValue('firstname', resData.firstname ?? '');
      formikPersonal.setFieldValue('lastname', resData.lastname ?? '');
      formikPersonal.setFieldValue('position', resData.position ?? '');
      formikPersonal.setFieldValue('phoneNumber', resData.phoneNumber ?? '');
      // Company Part
      formikCompany.setFieldValue('name', resData.company?.name ?? '');
      formikCompany.setFieldValue('streetAddress', resData.company?.address ?? '');
      // formikCompany.setFieldValue('city', resData.company?. ?? '');
      // formikCompany.setFieldValue('state', resData.company?.name ?? '');
      // formikCompany.setFieldValue('zipCode', resData.company?.name ?? '');
    }
  }, [data]);

  return {
    formikLogin,
    formikPersonal,
    formikCompany,
    isLoading: {
      initial: isLoading,
      password: passwordLoad,
      personal: personalLoad,
    },
  };
}

export default useEditUserProfile;
